export default {"src":"/_next/static/media/plan-icon-flower-rose.c5884964.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};